// extracted by mini-css-extract-plugin
module.exports = {"power-independence-O":"O_power-independence-O__dKch8"};